<template>
    <div class="table-container-compact">
        <table class="table-compact">
            <thead>
                <tr>
                    <th style="width: 50px; text-align: center">#</th>
                    <th style="text-align: center; min-width: 120px">작업일시</th>
                    <th style="text-align: center">엔티티</th>
                    <th style="width: 50px; text-align: center">ID</th>
                    <th style="text-align: center; width: 120px">액션</th>
                    <th style="text-align: center">작업자</th>
                    <th style="text-align: center; max-width: 160px">비고</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td colspan="7" class="text-center"><i class="fas fa-spinner fa-spin"></i> 로딩 중...</td>
                </tr>
                <tr v-else-if="!logs || logs.length === 0">
                    <td colspan="7" class="text-center empty">조회된 감사 로그가 없습니다</td>
                </tr>
                <tr
                    v-else
                    v-for="row in logs"
                    :key="row.logIdx"
                    class="clickable-row"
                    @click="$emit('row-click', row)"
                    tabindex="0"
                    @keydown.enter="$emit('row-click', row)"
                    @keydown.space.prevent="$emit('row-click', row)"
                >
                    <td style="text-align: center">{{ row.logIdx }}</td>
                    <td style="text-align: center">{{ formatDate(row.actionDate || row.regDate) }}</td>
                    <td style="text-align: center">{{ getEntityLabel(row.entity) }}</td>
                    <td style="text-align: center">{{ row.entityIdx }}</td>
                    <td style="text-align: center">
                        <span
                            class="tag-small action-badge"
                            :class="getActionClass(row.action)"
                            :title="getActionLabel(row.action)"
                        >
                            {{ getActionLabel(row.action) }}
                        </span>
                    </td>
                    <td style="text-align: center">{{ row.worker || "-" }}</td>
                    <td style="text-align: center" :title="row.remarks && row.remarks.length > 30 ? row.remarks : null">
                        {{ truncate(row.remarks, 30) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CarbonCodes from "../../../codes/carbonCodes";

export default {
    name: "AuditLogTable",
    props: {
        logs: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        entityLabelMap: { type: Object, default: () => ({}) },
        actionLabelMap: { type: Object, default: () => ({}) },
    },
    methods: {
        formatDate(val) {
            if (!val) return "-";
            const d = typeof val === "string" ? new Date(val) : val;
            if (isNaN(d.getTime())) return val;
            return d.toLocaleString("ko-KR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
        getEntityLabel(code) {
            return this.entityLabelMap[code] || code || "-";
        },
        getActionLabel(code) {
            return this.actionLabelMap[code] || code || "-";
        },
        getActionClass(code) {
            const meta = CarbonCodes.auditAction.getMeta(code) || {};
            return `action-${(meta && meta.color) || "default"}`;
        },
        truncate(str, len) {
            if (!str) return "-";
            return str.length <= len ? str : str.slice(0, len) + "…";
        },
    },
};
</script>

<style scoped>
/* ActivityConfigTable / StandardSettingsPanel과 동일한 테이블·row 스타일 */
/* .text-center 는 전역 _carbon-tables.scss 적용 */
.empty {
    padding: 30px;
    color: #94a3b8;
}
.tag-small.action-badge {
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 500;
}
.action-green {
    background: #bbf7d0;
    color: #14532d;
    font-weight: 600;
}
.action-blue {
    background: #bfdbfe;
    color: #1e3a8a;
    font-weight: 600;
}
.action-red {
    background: #fecaca;
    color: #991b1b;
    font-weight: 600;
}
.action-gray {
    background: #e2e8f0;
    color: #334155;
}
.action-purple {
    background: #e9d5ff;
    color: #581c87;
    font-weight: 600;
}
.action-orange {
    background: #fed7aa;
    color: #9a3412;
    font-weight: 600;
}
.action-default {
    background: #e2e8f0;
    color: #475569;
}
/* 테이블 반응형 overflow-x 는 전역/기본 동작에 의존 */
</style>
